import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

/**
 * @typedef {import('./type').CommonConfig} CommonConfig
 */

function getUrl() {
  return 'v1/common/config/';
}

/**
 * @param {string} url
 */
function callbackFetch(url) {
  /**
   * @returns {Promise<CommonConfig>}
   */
  return async () => {
    try {
      const res = await fetcher.get(url);
      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export default function fetch() {
  const url = getUrl();

  return {
    cb: callbackFetch(url),
    key: [url],
  };
}
